export function getLastTwoMinutesOptions() {
  return LAST2;
}

export function getRorationOptions() {
  return ROTATION;
}

export function getClutchGarbageOptions() {
  return CLUTCHGARBAGE;
}

export function getHomeAwayOptions() {
  return HOMEAWAY;
}

export function getConferenceOptions() {
  return CONFERENCE;
}

export function getPeriodsOptions(numberOfPeriods = 0) {
  const options = [{ label: 'All', value: '' }];

  for (let n = 1; n <= numberOfPeriods; n++) {
    const value = '' + n;
    options.push({ label: value, value });
  }
  options.push({ label: 'OT', value: 'ot' });

  return options;
}

const LAST2 = [
  { name: 'All', id: '' },
  { name: 'Last 2 Minutes', id: 'last2' },
  { name: 'Standard', id: 'standard' },
];

const ROTATION = [
  { name: 'All', id: '' },
  { name: 'Rotation', id: 'rotation' },
  { name: 'Starter', id: 'starter' },
];
const CLUTCHGARBAGE = [
  { label: 'Clutch', value: 'is_clutch' },
  { label: 'Garbage', value: 'is_garbage' },
  { label: 'Normal', value: 'is_normal' },
];

const HOMEAWAY = [
  { name: 'All', id: '' },
  { name: 'Home', id: 'home' },
  { name: 'Away', id: 'away' },
];

const CONFERENCE = [
  { name: 'All', id: '' },
  { name: 'In', id: 'in' },
  { name: 'Out', id: 'out' },
];
